import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  memberDetails: null,
  searchedLocationOption: null,
  searchedLocationList: null,
  appliedGymsFilter: null,
};

export const eligibilityLookupSlice = createSlice({
  name: 'eligibility-lookup',
  initialState,
  reducers: {
    setMemberDetails: (state, action) => {
      state.memberDetails = action.payload;
    },
    setSearchedLocationOption: (state, action) => {
      state.searchedLocationOption = action.payload;
    },
    setSearchedLocationList: (state, action) => {
      state.searchedLocationList = action.payload;
    },
    setAppliedGymsFilter: (state, action) => {
      state.appliedGymsFilter = action.payload;
    },
    resetLocationGymsFilter: (state) => {
      state.searchedLocationOption = null;
      state.searchedLocationList = null;
      state.appliedGymsFilter = null;
    },
  },
});

export const actions = eligibilityLookupSlice.actions;
export const reducer = eligibilityLookupSlice.reducer;
